import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL+'/planValue';

export const savePlanValue = async(token,planValue) => {
  let response = null   
  try{
      response = await axios.post(API_BASE_URL,planValue,{ 
          headers: {                                                                
                  'Authorization': `Bearer ${token}`                                  
                  }
          });   
          
  }catch(error){  
      response = error.response;                  
      console.log('PlanValueService -> savePlanValue: '+error);
  }finally {
      return response.data;
  }
}

export const getPlanValueListByPlanId = async(token,planId) => {
    let planValuList = null
    try{
        planValuList = await axios.get(API_BASE_URL + "?planId="+planId+"&order=DESC",{ 
            headers: {                                                                                                   
                    'Authorization': `Bearer ${token}`                                                   
                    }            
            });           
        return planValuList.data;
    }catch(error){             
        console.log('PlanValueService -> getPlanValueListByPlanId: '+error);
    }
}

export const getLatestPlanValueListByPlanId = async(token,planId) => {
    let planValue = null
    try{
        planValue = await axios.get(API_BASE_URL + "/latest?planId="+planId,{ 
            headers: {                                                                                                   
                    'Authorization': `Bearer ${token}`                                                   
                    }            
            });            
        return planValue.data;
    }catch(error){             
        console.log('PlanValueService -> getLatestPlanValueListByPlanId: '+error);
    }
}
